import { render } from "./SearchEventsForm.vue?vue&type=template&id=37de6405"
import script from "./SearchEventsForm.vue?vue&type=script&lang=js"
export * from "./SearchEventsForm.vue?vue&type=script&lang=js"

import "./SearchEventsForm.vue?vue&type=style&index=0&id=37de6405&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__